
<div style="text-align:center;">
  @for (button of params.buttons; track button; let i = $index) {
    <button [disabled]="params.enabled && !params.enabled(params)"
      (click)="onClick(i)"
      [title]="button.label"
      [attr.aria-label]="button.label"
      style="margin-right: 3px">
      @if (isVisible(i)) {
        <span>
          @if (button.icon === 'edit') {
            <svg-icon title="Edit" icon="icon-pencil" class="small dark-gray cursor-pointer" aria-hidden="true"></svg-icon>
          }
          @if (button.icon === 'delete') {
            <svg-icon title="Delete" icon="icon-trash" class="small dark-gray cursor-pointer" aria-hidden="true"></svg-icon>
          }
          @if (button.icon === 'up') {
            <svg-icon title="Up" icon="icon-caret-up" class="small dark-gray cursor-pointer" aria-hidden="true"></svg-icon>
          }
          @if (button.icon === 'down') {
            <svg-icon title="Down" icon="icon-caret-down" class="small dark-gray cursor-pointer" aria-hidden="true"></svg-icon>
          }
          @if (button.icon === 'copy') {
            <svg-icon title="Copy" icon="icon-clipboard" class="small medium-gray cursor-pointer" aria-hidden="true"></svg-icon>
          }
          @if (button.icon === 'save') {
            <svg-icon title="Save" icon="icon-save" class="tiny medium-gray cursor-pointer" aria-hidden="true"></svg-icon>
          }
          @if (button.icon === 'cancel') {
            <svg-icon title="Cancel" icon="icon-x" class="small medium-gray cursor-pointer" aria-hidden="true"></svg-icon>
          }
          @if (button.icon === 'view') {
            <svg-icon title="View" icon="icon-report-preview" class="small medium-gray cursor-pointer" aria-hidden="true"></svg-icon>
          }
          @if (button.icon === 'download') {
            <svg-icon title="Download" icon="icon-download" class="small medium-gray cursor-pointer" aria-hidden="true"></svg-icon>
          }
        </span>
      }
    </button>
  }
</div>
